import { Dialog } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly fullScreen?: boolean;
}

export const ApplicationDialog: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { children, fullScreen = false } = props;

  if (fullScreen) {
    return (
      <Dialog open={true} fullScreen={true}>
        {children}
      </Dialog>
    );
  }

  return (
    <>
      <Backdrop sx={styles.backdrop} open={true} />
      <Box sx={styles.paperContainer}>{children}</Box>
    </>
  );
};

const styles: Record<string, SystemStyleObject> = {
  paperContainer: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    margin: 'auto',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 4,
  },
  backdrop: {
    zIndex: 3,
  },
};
